/* RESPONSIBLE TEAM: team-ml */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type { Router } from '@ember/routing';

export default class WorkforceRoute extends Route {
  @service declare session: Session;
  @service declare router: Router;

  beforeModel() {
    if (!this.session.workspace.isFeatureEnabled('wfm-v0')) {
      this.router.transitionTo('inbox.workspace.inbox');
    }
  }
}
